// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3MYMd","label":"SetPasswdForm_label__1hm-P"};